<template>
    <main class="home">
        <!-- Header -->
        <Header />

        <!-- Hero Banner -->
        <HeroBanner />

        <!-- Portfolio Themes -->
        <PortfolioThemes />

        <!-- Blog Themes -->
        <BlogThemes />

        <!-- Business Themes -->
        <BusinessThemes />

        <!-- Documentation Themes -->
        <DocumentationThemes />

        <!-- Github Themes -->
        <GithubThemes />

        <!-- CTA -->
        <CTA
                title="Get updates from Jekyll Themes."
                desc="
            We email our list around once a month with all the latest
            theme updates, special offers and useful resources." />

        <!-- Footer -->
        <Footer title="Premium & free Jekyll themes for your blog or website." />
    </main>
</template>

<script>
    import Header from "../components/common/Header";
    import HeroBanner from "../components/sections/HeroBanner";
    import PortfolioThemes from "../components/sections/PortfolioThemes";
    import BlogThemes from "../components/sections/BlogThemes";
    import BusinessThemes from "../components/sections/BusinessThemes";
    import DocumentationThemes from "../components/sections/DocumentationThemes";
    import GithubThemes from "../components/sections/GithubThemes";
    import CTA from "../components/sections/CTA";
    export default {
        name: "Home",
        components: {
            CTA,
            GithubThemes,
            DocumentationThemes,
            BusinessThemes,
            BlogThemes,
            PortfolioThemes,
            HeroBanner,
            Header
        }
    }
</script>

<style scoped>

</style>